// extracted by mini-css-extract-plugin
export default {"cls1":"LockedOut-Section_cls1__S72Xz","cls2":"LockedOut-Section_cls2__dj40A LockedOut-Section_cls1__S72Xz"};